<template>
    <Modal :open="open" :is-card="true" :show-close-icon="true" :is-dismissed-on-click-backdrop="false" @close="closeResumeConfigurationModal" :narrow="false">
        <h2 class="title">You have an ongoing configuration</h2>

        <p class="body">It seems you have already started configuring a {{ localStorageData.model }}. Would you like to continue?</p>

        <div class="footer">
            <button type="button" @click="continueConfiguration" class="btn btn--primary btn--long btn--full-width-xs">Continue <span class="hidden__xs">configuration</span></button>

            <button type="button" @click="startNewConfiguration" class="btn btn--primary-inverted btn--long btn--full-width-xs"><span class="hidden__xs">Start </span>new configuration</button>
        </div>
    </Modal>
</template>

<script>
import Modal from "../../core/components/Modal.vue";
import {getBestMatchingRouteBasedOnCurrentState} from "../routes/modules/routeRequirements";

export default {
    components: {
        Modal
    },
    props: {
        open: {
            default: false,
        },
    },
    methods: {
        closeResumeConfigurationModal: function () {
            this.$emit('close-resume-configuration-modal');
        },

        continueConfiguration: function () {
            this.$store.dispatch('getConfigById', this.localStorageData.configuratorId).then(response => {
                const bestRouteToRedirectTo = getBestMatchingRouteBasedOnCurrentState();

                if (!this.$route.query.id) {
                    this.$router.push({
                        name: bestRouteToRedirectTo,
                        query: {...this.$route.query, id: response.id},
                        params: {...this.$route.params, urlModel: response.new_model.url_model},
                    });
                } else {
                    this.$router.push({
                        name: bestRouteToRedirectTo,
                        query: this.$route.query,
                        params: {...this.$route.params, urlModel: response.new_model.url_model},
                    });
                }
            }).catch(error => {
                console.error(error)
            });
        },

        startNewConfiguration: function () {
            localStorage.removeItem(`configurator-${this.$route.params.brand}`);
            this.closeResumeConfigurationModal();
        }
    },
    computed: {
        localStorageData() {
            return JSON.parse(localStorage.getItem(`configurator-${this.$route.params.brand}`));
        }
    }
}
</script>

<style lang="scss" scoped>
.title {
    text-align: center;
    color: #192A44;
    margin-bottom: 10px;
}

.body {
    text-align: center;
    margin-bottom: 22px;
}

.footer {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 100%;
    align-items: center;
}

.btn--long {
    @media (min-width: 768px) {
        width: 70%;
    }
    box-shadow: 0 11px 24px rgba(0, 0, 0, 0.07);
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/configurator/components/ResumeConfigurationModal.vue